import React, {useContext} from 'react';
// import video1 from "../../assets/videos/video1.mp4";
import {LangContext} from "../../App";

const HomeVideo = () => {
    const lang = useContext(LangContext)

    const content = {
        en: {
            title: "Experience Armenia with Those Who Know It Best",
            description: "A land where history breathes, mountains guard centuries of faith, and every road carries a story. With Ayrarat Tours, each journey is authentic, thoughtfully crafted, and truly personal — the Ayrarat way."
        },
        de: {
            title: "Erleben Sie Armenien mit denen, die es am besten kennen",
            description: "Ein Land, in dem die Geschichte atmet, Berge Jahrhunderte des Glaubens bewachen und jede Straße eine Geschichte erzählt. Mit Ayrarat Tours ist jede Reise authentisch, liebevoll gestaltet und wirklich persönlich – auf die Ayrarat-Art."
        },
    }

    const { title, description } = content[lang] || content.en;

    return (
        <div className='home-video'>
            <video controls={false} muted autoPlay loop>
                <source src={''} type="video/mp4"/>
            </video>
            <div className="cover"></div>
            <div className="info">
                <h2>{title}</h2>
                <p>{description}</p>
            </div>
        </div>
    );
};

export default HomeVideo;